import { COLLECTIONS } from '__constants__'
import { getFormattedDateAndTime } from 'helpers'
import { useDocument } from 'services/api/firebase'
import { useGetLocation } from 'domains/Location/hooks'
import { useLoading } from 'hooks'
import { useMemo } from 'react'

const useGetNewsTipInitialValues = (id) => {
  /* Fetching data using useDocument hook */
  const [newsTip, newsTipLoading] = useDocument({
    ref: id ? COLLECTIONS.NEWS_TIPS + '/' + id : null
  })

  /* Get formatted date and time */
  const dateAndTime =
    !newsTipLoading && getFormattedDateAndTime(newsTip?._createdAt)

  /* Get formatted date and time */
  const [location, locationLoading] = useGetLocation(newsTip?.locationId)

  /* Merge all fetched data */
  const initialValues = useMemo(
    () => ({
      newsTip: { ...newsTip, dateAndTime },
      location
    }),
    [newsTip, dateAndTime, location]
  )

  /* Merge all loading states */
  const loadings = useMemo(
    () => (id ? [!newsTip, newsTipLoading, locationLoading] : []),
    [id, newsTip, newsTipLoading, locationLoading]
  )
  /* Getting loading state using merged loadings */
  const loading = useLoading(loadings)

  return [initialValues, loading]
}

export default useGetNewsTipInitialValues
